export function formatCurrency(value: number, decimals = 2) {
  if (typeof value !== 'number' || isNaN(value)) return 0;
  return Number(value.toFixed(decimals));
}

export function formatCentsToUSD(cents?: number | null): string {
  if (cents == null || isNaN(cents)) return '';

  const absCents = Math.abs(cents);
  const dollars = Math.floor(absCents / 100);
  const centsPart = absCents % 100;
  const sign = cents < 0 ? '-' : '';

  // Format dollars with commas
  const formattedDollars = dollars.toLocaleString('en-US');
  // Always show two digits for cents
  const formattedCents = centsPart.toString().padStart(2, '0');

  return `${sign}$${formattedDollars}.${formattedCents}`;
}

export function formatStringToCents(value: string): number | undefined {
  const cleanedString = value.replace(/[^0-9.-]+/g, '');
  const floatValue = parseFloat(cleanedString);
  if (isNaN(floatValue)) return undefined;
  return Math.round(floatValue * 100);
}
